import { Box, Typography, alpha } from "@mui/material";
import { useTheme } from "@mui/system";

/**
 * Success message component shown when QR code is scanned
 * @returns {JSX.Element} Success message component
 */
export const QRScanSuccess = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: alpha(theme.palette.success.main, 0.1),
        color: theme.palette.success.main,
        p: 2,
        mb: 3,
        borderRadius: "8px",
        border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography fontWeight={500}>QR Code scanned successfully!</Typography>
    </Box>
  );
};
